import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import SelectChip from '../../../form/component/SelectChip'
import currentUserHasAccess from '../../../../util/widget-helper'
import {ATTACHMENT_AGREEMENT_WIDGET} from '../../ui-definition/process-ui'
import { ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT } from '../../../anamnesis/state/anamnesis/const'
import BeatLoader from "react-spinners/BeatLoader";

const AGREEMENT_VALUES = [
    {
        value: true,
        label: 'Yes, patient agrees to Attachment if needed',
    },
    {
        value: false,
        label: 'No, patient does not agree to Attachment if needed',
    },
]

const WIDGET_TITLE = 'Attachment Patient Agreement';

const AttachmentAgreementWidget = ({
    readOnly,
    isAttachmentProviderStore,
    anamnesis,
    fetching,
    changeAnamnesis,
    saveAnamnesis,
}) => {

     if (!currentUserHasAccess(ATTACHMENT_AGREEMENT_WIDGET) || !anamnesis) {
         return null
     }

    // force readOnly to be true if clinic do not offer attachment
    const internalReadOnly = isAttachmentProviderStore ? readOnly : true;

    const changeFormData = (name, value) => {
        const payload = {
            ...anamnesis.formData,
            attachmentAgreed: value,
        }

        changeAnamnesis('formData', payload, ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT);
        saveAnamnesis(ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT);
    }

    // prevent crash during data loading
    if (fetching && !internalReadOnly) {
        return <ContentBox title={WIDGET_TITLE}>
            <Row>
                <Column size={6}>
                    <p>Loading... Please wait.</p>
                    <BeatLoader loading={fetching}/>
                </Column>
            </Row>
        </ContentBox>
    }

    return (
        <React.Fragment>
            { anamnesis && <ContentBox title={WIDGET_TITLE}>
                <Row>
                    <Column size={6}>
                        {!isAttachmentProviderStore &&
                            <p><i>Clinic does not offer Attachment</i></p>
                        }
                        <LabelInput label="">
                            <SelectChip
                                object={anamnesis.formData}
                                name="attachmentAgreed"
                                readOnly={internalReadOnly}
                                addEmpty={true}
                                valueList={AGREEMENT_VALUES}
                                onChange={changeFormData}
                            />
                        </LabelInput>
                    </Column>
                </Row>
            </ContentBox> }
        </React.Fragment>
    )
}

AttachmentAgreementWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    anamnesis: PropTypes.object,
    changeAnamnesis: PropTypes.func.isRequired,
    saveAnamnesis: PropTypes.func.isRequired,
    isAttachmentProviderStore: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
}

export default AttachmentAgreementWidget



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/AttachmentAgreementWidget.js